
import axios from 'axios'
import { signRequest } from 'common/sign'
import { getToken } from '../utils/Session'
import appStore from '../store/appStore'

const secretKey = 'cbff737a4f1b8cb3'

function redirectToLogin() {
    appStore.toggleLogin(false)

    if (typeof window !== 'undefined' && window.location.hash !== '#/login') {
        const loginUrl = window.location.pathname + window.location.search + '#/login'
        window.location.replace(loginUrl)
    }
}

function axios_request(method, url, params, data) {
    let timestamp = Date.now().toString()
    let signature = signRequest(url, params, timestamp, secretKey)
    let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Sign-Timestamp': timestamp,
        'Signature': signature
    }
    const token = getToken()
    if (token) {
        headers['Authorization'] = 'Bearer ' + token
    }
    return axios({
        method: method,
        url: url,
        data: data,
        params: params,
        headers: headers
    }).catch(error => {
        if (error && error.response && error.response.status === 401) {
            redirectToLogin()
            error.isAuthError = true
        }
        return Promise.reject(error)
    })
}

export function queryAccountOrder(params) {
    return axios_request('get', '/api/query/order', params, null)
}
export function logoutAuth() {
    return axios_request('post', '/api/auth/logout', {}, null)
}
export function queryStrategyPosition(params) {
    return axios_request('get', '/api/strategy/position', params, null)
}
export function queryStrategyNameList(params) {
    return axios_request('get', '/api/app-name/list', params, null)
}
export function querySlippageStrategyNameList(params) {
    return axios_request('get', '/api/slippage-app-name/list', params, null)
}
export function querySymbolList(params) {
    return axios_request('get', '/api/symbol/list', params, null)
}
export function queryBnSymbolOption(params) {
    return axios_request('get', '/api/v2/data/symbol-option', params, null)
}
export function queryPositonSymbolStrategyList(params) {
    return axios_request('get', '/api/position/symbol-strategy-list', params, null)
}
export function queryTradeCurve(params) {
    return axios_request('get', '/api/query/trade-curve', params, null)
}
export function queryTurnoverRate(params) {
    return axios_request('get', '/api/analyze/turnover-rate', params, null)
}
export function querySlippageAnalyze(params) {
    return axios_request('get', '/api/analyze/slippage', params, null)
}
export function queryFeeAnalyze(params) {
    return axios_request('get', '/api/analyze/fee', params, null)
}
export function queryBnOriginKline(params) {
    return axios_request('get', '/api/query/bn-kline', params, null)
}
export function queryBalanceReal(params) {
    return axios_request('get', '/api/balance/real', params, null)
}
export function queryTodayProfitOverall(params) {
    return axios_request('get', '/api/today-profit/overall', params, null)
}
export function queryBalanceCurve(params) {
    return axios_request('get', '/api/balance/curve', params, null)
}
export function queryIndicatorAlt(params) {
    return axios_request('get', '/api/indicator/alt', params, null)
}
export function queryHomeMarket(params) {
    return axios_request('get', '/api/v2/home/market', params, null)
}
export function queryHomeOverview(params) {
    return axios_request('get', '/api/v2/home/overview', params, null)
}
export function queryHomeEquityCurve(params) {
    return axios_request('get', '/api/v2/home/equity-curve', params, null)
}
export function queryHomeStrategySymbolPnl(params) {
    return axios_request('get', '/api/v2/home/strategy-symbol-pnl', params, null)
}
export function queryStrategyOption(params) {
    return axios_request('get', '/api/strategy/option', params, null)
}
export function queryTradeStrategyList(params) {
    return axios_request('get', '/api/strategy/list', params, null)
}
export function queryStrategyBkResult(params) {
    return axios_request('get', '/api/strategy/bk-result', params, null)
}
export function queryBkTraceEquityCurveCmp(params) {
    return axios_request('get', '/api/strategy/bk-trade-cmp-curve', params, null)
}
export function queryBkTraceSelectCoinCmp(params) {
    return axios_request('get', '/api/strategy/bk-trade-cmp-select-coin', params, null)
}
export function queryTradeStrategyIdAppNameList(params) {
    return axios_request('get', '/api/strategy/id-app-name-option', params, null)
}
export function queryTradeStrategyTraverseParam(params) {
    return axios_request('get', '/api/strategy/traverse-param', params, null)
}
export function queryFundingOption(params) {
    return axios_request('get', '/api/data/funding-option', params, null)
}
export function queryFundingRate(params) {
    return axios_request('get', '/api/query/funding-rate', params, null)
}
export function queryFundingFeeCurve(params) {
    return axios_request('get', '/api/query/funding-fee-curve', params, null)
}
export function queryPigDiffPrice(params) {
    return axios_request('get', '/api/indicator/pig-diff', params, null)
}
export function queryStrategyTraversalResult(params) {
    return axios_request('get', '/api/strategy/traversal-result', params, null)
}
export function queryAllFactorColList(params) {
    return axios_request('get', '/api/factor/all-col-list', params, null)
}
export function queryFactorCrossData(params) {
    return axios_request('get', '/api/factor/cross-data', params, null)
}
export function queryFactorSeriesData(params) {
    return axios_request('get', '/api/factor/series-data', params, null)
}
export function queryBackSelectCoin(params) {
    return axios_request('get', '/api/query/select-coin', params, null)
}
export function queryTransferInner(params) {
    return axios_request('get', '/api/query/transfer-inner', params, null)
}
export function queryCcyList(params) {
    return axios_request('get', '/api/ccy/list', params, null)
}
export function queryAccountNameList(params) {
    return axios_request('get', '/api/account/name-list', params, null)
}
export function queryTransferSub(params) {
    return axios_request('get', '/api/query/transfer-sub', params, null)
}
export function queryHeatmapConfig(params) {
    return axios_request('get', '/api/heatmap/config', params, null)
}
export function queryHeatmapData(params) {
    return axios_request('get', '/api/heatmap/data', params, null)
}
export function queryIndicatorMarketChange(params) {
    return axios_request('get', '/api/indicator/market-change', params, null)
}
export function queryStkFutYearlyProfit(params) {
    return axios_request('get', '/api/stk-futures/yearly-profit', params, null)
}
export function queryStkFutRollCurve(params) {
    return axios_request('get', '/api/stk-futures/roll-curve', params, null)
}
export function queryAnnualPriceDiff(params) {
    return axios_request('get', '/api/indicator/annual-diff', params, null)
}
export function querySymbolAnnualDiff(params) {
    return axios_request('get', '/api/symbol/annual-diff', params, null)
}
export function querySymbolVolumeSymbol(params) {
    return axios_request('get', '/api/symbol/symbol-volume', params, null)
}
export function queryIndicatorDiffusion(params) {
    return axios_request('get', '/api/indicator/diffusion', params, null)
}
export function queryTradeVolumeRatio(params) {
    return axios_request('get', '/api/query/symbol-trade-volume-ratio', params, null)
}
export function queryShardVolumeRatio(params) {
    return axios_request('get', '/api/query/symbol-shard-volume-ratio', params, null)
}
export function queryStrategyTradeConfig(params) {
    return axios_request('get', '/api/query/strategy-trade-config', params, null)
}



// WEBPACK FOOTER //
// ./src/common/request.js